export default __webpack_public_path__ + "static/media/IMG_1008.bb721c25.bb721c25.JPG";